
import { Badge } from "@/components/ui/badge";
import { UserRole } from "@/types";
import { ShieldCheck, ShieldAlert, UserCheck } from "lucide-react";

interface PermissionBadgeProps {
  role: UserRole;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const PermissionBadge = ({ role, showIcon = true, size = 'md' }: PermissionBadgeProps) => {
  const sizeClasses = {
    sm: 'text-xs py-0 px-2',
    md: 'text-sm py-1 px-2',
    lg: 'text-md py-1 px-3'
  };
  
  switch (role) {
    case UserRole.ADMIN:
      return (
        <Badge variant="secondary" className={`bg-blue-100 text-blue-800 hover:bg-blue-200/80 flex items-center gap-1 font-medium ${sizeClasses[size]}`}>
          {showIcon && <ShieldCheck className="h-3 w-3" />}
          Administrador
        </Badge>
      );
    case UserRole.PARCEIRO:
      return (
        <Badge variant="secondary" className={`bg-purple-100 text-purple-800 hover:bg-purple-200/80 flex items-center gap-1 font-medium ${sizeClasses[size]}`}>
          {showIcon && <ShieldAlert className="h-3 w-3" />}
          Parceiro
        </Badge>
      );
    case UserRole.VENDEDOR:
      return (
        <Badge variant="secondary" className={`bg-green-100 text-green-800 hover:bg-green-200/80 flex items-center gap-1 font-medium ${sizeClasses[size]}`}>
          {showIcon && <UserCheck className="h-3 w-3" />}
          Vendedor
        </Badge>
      );
    default:
      return (
        <Badge variant="secondary" className={`bg-gray-100 text-gray-800 hover:bg-gray-200/80 flex items-center gap-1 font-medium ${sizeClasses[size]}`}>
          Usuário
        </Badge>
      );
  }
};
